export const overlaySelector = (state) => state.overlay;
